import history from '../../../../history'
import { Button } from '../../..'
import { useSelector } from 'react-redux'
import { useIntl, defineMessages } from 'react-intl'
import { PATH_HELPERS } from '../../../../constants/navigation'
import { selectFilter } from '../../../../store/selectors/filters'
import { selectCustomerId } from '../../../../store/selectors/customerProfile'

import styles from './FiltersFooterButtons.module.scss'

export const MSG = defineMessages({
  cancel: {
    id: 'General.cancel',
    defaultMessage: 'Cancel',
  },
  reset: {
    id: 'HomeSearch.listings.filters.reset',
    defaultMessage: 'Reset filters',
  },
  apply: {
    id: 'General.apply',
    defaultMessage: 'Apply',
  },
})

export interface FiltersFooterButtonsProps {
  onClose: () => void
}

export const FiltersFooterButtons = ({
  onClose,
}: FiltersFooterButtonsProps) => {
  const intl = useIntl()
  const filters = useSelector(selectFilter)
  const customerId = useSelector(selectCustomerId)

  const resetFilters = () => {
    history.push(
      `${PATH_HELPERS.listings.buildPath(
        customerId,
        filters.location.level,
        filters.location.name
      )}`
    )

    onClose()
  }

  return (
    <div className={styles.buttons}>
      <Button onClick={resetFilters} minimal danger>
        {intl.formatMessage(MSG.reset)}
      </Button>
      <div className={styles.buttonsRight}>
        <Button onClick={onClose}>{intl.formatMessage(MSG.cancel)}</Button>
        <Button primary type='submit'>
          {intl.formatMessage(MSG.apply)}
        </Button>
      </div>
    </div>
  )
}
